<template>
  <component
    @error="onError"
    :errorMessage="errorMessage"
    :is="componentName"
    @resetErrorMessage="onResetErrorMessage"
    @resetPasswordRequest="onResetPasswordRequest"
    @success="onSuccess"
    v-bind="$props"
  />
</template>

<script>
import { LoginConsts } from 'client/util/Constants';
import { UserRoutes } from 'client/routes/RouteGenerator';
import { get } from 'lodash';
import EmailEntry from 'client/containers/user/EmailEntry.vue';
import MfaApiResponseHandler from 'client/containers/Login/MfaApiResponseHandler';
import PasswordEntry from 'client/containers/user/PasswordEntry.vue';
import Util from 'client/util/Util';


const { responseMessages } = LoginConsts;
const {
  loginError,
  mfaRequired,
  passwordRequired,
} = responseMessages;
const { resetPassword } = UserRoutes;

export default {
  name: 'UserLoginController',

  redirect: Util.redirect,

  components: {
    EmailEntry,
    PasswordEntry,
  },

  props: {
    goToAdminLogin: {
      type: Function,
      required: true,
    },
    redirectTo: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      default: () => ({
        email: '',
        password: '',
      }),
    },
  },

  data() {
    return {
      componentName: 'EmailEntry',
      errorMessage: '',
    };
  },

  methods: {
    handleContinueLogin(response) {
      const message = get(response, 'data.message', loginError);
      const isMfaRequired = message === mfaRequired;

      return isMfaRequired ? this.handleMfaRedirect(response) : this.handleInputPassword();
    },

    handleMfaRedirect(response) {
      const factors = get(response, 'data.factors', []);

      // replace this with single page flow (change componentName)
      // completion as part of AUTH-7224
      return this.$router.push(MfaApiResponseHandler({ factors }, { redirectTo: this.redirectTo }));
    },

    handleInputPassword() {
      this.componentName = 'PasswordEntry';
    },

    handleNavigate(url = this.redirectTo) {
      // completion as part of AUTH-7224
      // there is potential that this is all that is needed for redirect
      this.$options.redirect(url);
    },

    onError(error) {
      const { response } = error;
      const message = get(response, 'data.message', loginError);

      const isMfaRequired = message === mfaRequired;
      const isPasswordRequired = message === passwordRequired;
      const isValidLogin = isMfaRequired || isPasswordRequired;

      return isValidLogin
        ? this.handleContinueLogin(response)
        : this.setErrorMessage(message);
    },

    onSuccess() {
      this.handleNavigate();
    },

    onResetPasswordRequest() {
      this.$router.push({ path: resetPassword });
    },

    onResetErrorMessage() {
      this.errorMessage = '';
    },

    setErrorMessage(message) {
      this.errorMessage = message;
    },
  },
};
</script>

<style module>
</style>
